import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    GET_BOM_DETAIL,
    STORE_NEW_FOLDING,
    GET_FOLDING_DETAIL,
    SHOW_MESSAGE
} from "../ActionTypes";
import JwtAxios from "../../apiServices";
import {GET_FOLDING_ENDPOINT, STORE_FOLDING_ENDPOINT} from "../../apiServices/API_ENDPOINTS";
import HandleNotification from "../../common/Notification";

export const onFoldingStore = (folding) => {
    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios
            .post(`${STORE_FOLDING_ENDPOINT}`, folding)
            .then((data) => {
                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: STORE_NEW_FOLDING, payload: data.data});
                    dispatch({
                        type: SHOW_MESSAGE,
                        payload: "Folding Information Stored Successfully",
                    });
                    HandleNotification('success', 'bottomRight', 'Folding Information Stored Successfully!', null)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                    HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

            });
    };
};

export const onGetFoldingDetails = (payload) => {

    return (dispatch) => {
        dispatch({type: FETCH_START});
        JwtAxios.post(`${GET_FOLDING_ENDPOINT}`, payload)
            .then((data) => {

                if (data?.data?.code === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({type: GET_FOLDING_DETAIL, payload: data.data});
                    dispatch({

                        type: SHOW_MESSAGE,
                    });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: "Something went wrong!",
                    });
                }
            })
            .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                HandleNotification('error', 'bottomRight', 'Something went wrong!', null)

            });
    };
};

export const onResetFoldingDetails = () => {
    return (dispatch) => {
        dispatch({type: GET_FOLDING_DETAIL, payload: null});
    };
};